import styles from '../styles/app.module.css';

export function FooterCredit() {
  return (
    <a
      className={styles.footerCredit}
      href="https://www.originalfunction.com"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Made by Original Function"
    >
      Made by <strong>Ofunc</strong>
    </a>
  );
}
